var _desc, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon Country/portugal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Country/portugal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "portugal",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,256 C0,366.07 69.472,459.905 166.955,496.076 L189.217,255.999 L166.955,15.923 C69.472,52.095 0,145.929 0,256 Z",
    id: "Path",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512,256 C512,114.616 397.384,0 256,0 C224.686,0 194.689,5.633 166.955,15.923 L166.955,496.077 C194.689,506.368 224.686,512 256,512 C397.384,512 512,397.384 512,256 Z",
    id: "Path",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFDA44",
    cx: 166.957,
    cy: 256,
    r: 89.043
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.87,211.478 L116.87,267.13 C116.87,294.792 139.294,317.217 166.957,317.217 C194.62,317.217 217.044,294.793 217.044,267.13 L217.044,211.478 L116.87,211.478 Z",
    id: "Path",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.957,283.826 C157.751,283.826 150.261,276.336 150.261,267.13 L150.261,244.87 L183.652,244.87 L183.652,267.131 C183.652,276.336 176.162,283.826 166.957,283.826 Z",
    id: "Path",
    fill: "#F0F0F0"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPt);
export default __webpack_public_path__ + "static/media/PT.aef04cc71d63ccfda1b385f914a3370c.svg";
export { ForwardRef as ReactComponent };